import { Component, Input, Output, EventEmitter } from '@angular/core';
import { GenericService } from '../services/generic.service';
import { Generic } from '../models/generic.model';
import { NotificationService } from '../services/notification.service';

@Component({
  selector: 'app-generic-form',
  templateUrl: './generic-form.component.html'
})
export class GenericFormComponent {
  constructor(public service: GenericService, private notificationService: NotificationService) { }

  @Input() model: Generic;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  submitted = false;

  ngOnInit() {
    //this.notificationService.showDatePicker();
  }

  onSubmit() {
    this.submitted = true;
    this.service.model = this.model;
    if (!this.model.genericID)
      this.insertRecord();
    else
      this.updateRecord();
  }


  insertRecord() {

    this.service.post().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.closeModal.emit(null);
      },
      err => { console.log(err); }
    )
  }

  updateRecord() {

    this.service.put().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.closeModal.emit(null);
      },
      err => {
        console.log(err);
      }
    )
  }


}

